export enum CustomerAddUpdateTab {
    nameAndContact = 'nameAndContact',
    addresses = 'addresses',
    bankAccount = 'bankAccount'
}